import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";

const PelvicUltrasoundForm = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const [isLoading, setIsLoading] = useState(false);
  const [providerList, setProviderList] = useState([]);
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
  const practiseid = window.getPracticeId();
const [showRtCystMassComment, setShowRtCystMassComment] = useState(false);
const [showLtCystMassComment, setShowLtCystMassComment] = useState(false);
const [showFibroidComment, setShowFibroidComment] = useState(false);
const [showComment, setShowComment] = useState({
  hormoneReplacement: false,
  birthControl: false,
});

 const initialFormState = {
  provider: "",
  examDate: dayjs().format("YYYY-MM-DD"),
  history: "",
  signature: "",
  rtOvary: { LONG: "", AP: "", TRANS: "", unit: "cm" },
  rtCystMass: { LC: "", AP: "", TRANS: "", unit: "cm" },
  ltOvary: { LONG: "", AP: "", TRANS: "", unit: "cm" },
  ltCystMass: { LC: "", AP: "", TRANS: "", unit: "cm" },
  uterus: { LONG: "", AP: "", TRANS: "", unit: "cm" },
  fibroid: { LONG: "", AP: "", TRANS: "", unit: "cm" },
  rtCystMassComment: "",
  ltCystMassComment: "",
  fibroidComment: "",
  position: "", // NL, AV, RV, TR, TL
  endometrium: { value: "", unit: "cm", fluid: "", mass: "" },
  culDeSac: { net: "", fluid: "" },
  lmp: "",
  hormoneReplacement: false,
  hormoneReplacementComment: "",
  birthControl: false,
  birthControlComment: "",
};


  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    if (ismodal) {
      getProviders();
    }
  }, [ismodal]);

  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const resetFormData = () => {
    setFormData(initialFormState);
  };
  const handleCommentToggle = (field) => {
  setShowComment((prev) => ({
    ...prev,
    [field]: !prev[field],
  }));
};


  const handleChange = (section, field, value) => {
  if (
    ["endometrium", "culDeSac"].includes(section)
    || ["rtOvary", "rtCystMass", "ltOvary", "ltCystMass", "uterus", "fibroid"].includes(section)
  ) {
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: value },
    }));
  } else if (["hormoneReplacement", "birthControl"].includes(field)) {
    setFormData((prev) => ({ ...prev, [field]: value }));
  } else {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }
};

const validateForm = () => {
  const errors = [];

  if (!formData.provider) errors.push("Provider is required.");
  if (!formData.examDate) errors.push("Exam Date is required.");
  if (!formData.history.trim()) errors.push("Patient History is required.");
  if (!formData.signature.trim()) errors.push("Signature is required.");

  

  // Endometrium required value and unit
  if (!formData.endometrium.value) {
    errors.push("Endometrium value is required.");
  }

  // Cul-de-sac
  if (!formData.culDeSac.net || !formData.culDeSac.fluid) {
    errors.push("Cul-de-Sac Net and Fluid values are required.");
  }

  // Position
  if (!formData.position) {
    errors.push("Position selection is required.");
  }

 

  return errors;
};


  const handleSave = async () => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
      try {
        setIsLoading(true);
        const selectedProvider = providerList.find((p) => p.providername === formData.provider);
let payload = {
  ...formData,
  patient_id: data?.patientid,
  pat_name: `${data?.firstname} ${data?.lastname}`,
  pat_dob: data?.dob,
  pat_age: age,
  pat_gender: data?.gender?.toUpperCase(),
  pathistory: formData.history,
  providername: formData.provider,
  providerid: selectedProvider?.providerid,
  // Flatten nested structures
  rtOvary: formData.rtOvary,
  rtCystMass: formData.rtCystMass,
  ltOvary: formData.ltOvary,
  ltCystMass: formData.ltCystMass,
  uterus: formData.uterus,
  fibroid: formData.fibroid,
  endometrium: formData.endometrium,
  culDeSac: formData.culDeSac,
  position: formData.position,
  lmp: formData.lmp,
  hormoneReplacement: formData.hormoneReplacement,
  hormoneReplacementComment: formData.hormoneReplacementComment,
  birthControl: formData.birthControl,
  birthControlComment: formData.birthControlComment,
  rtCystMassComment: formData.rtCystMassComment,
  ltCystMassComment: formData.ltCystMassComment,
  fibroidComment: formData.fibroidComment,
  signature: formData.signature,
};


        const user = await api.get('/auth/me');
        const [year, month, day] = formData.examDate.split("-");
        const formattedDate = `${month}/${day}/${year}`;

        const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
          "Worksheet_Type": "PELVIC_ULTRASOUND",
          "createdby": user?.username || '',
          "appurl": window.location.origin,
          "Exam_Date": formattedDate,
          "data": payload
        });

        if (response.status === 200) {
          const pdf = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`, {
            "filename": response?.data?.filename,
            "worksheet_type": "PELVIC_ULTRASOUND",
            "appurl": window.location.origin,
            "exam_date": formattedDate
          });
          setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
          setTimeout(() => {
            resetFormData();
            setIsmodal(false);
          }, 1000);
        } else {
          setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange(null, "provider", data.linked_provider);
    } else if (providerList.length > 0) {
      handleChange(null, "provider", providerList[0].providername);
    }
  }
}, [providerList, data]);
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">Pelvic ULTRASOUND</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
            #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Date of Birth:</span> {formattedDOB}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Age:</span> {age}  | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange(null, "provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.id} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input type="date" className="w-full border rounded px-2 py-1" value={formData.examDate} onChange={(e) => handleChange(null, "examDate", e.target.value)} />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea placeholder="Enter Patient History here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.history} onChange={(e) => handleChange(null, "history", e.target.value)} />
        </div>

     {/* RIGHT OVARY */}
<div className="grid grid-cols-4 gap-4 items-end mt-4">
  <div>
  <label className="block text-sm font-medium">Rt OV LONG</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.rtOvary.LONG}
    onChange={(e) => handleChange("rtOvary", "LONG", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">Rt OV AP</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.rtOvary.AP}
    onChange={(e) => handleChange("rtOvary", "AP", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">Rt OV TRANS</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.rtOvary.TRANS}
    onChange={(e) => handleChange("rtOvary", "TRANS", e.target.value)}
  />
</div>

  <div>
    <label className="block text-sm font-medium">Units</label>
    <select className="w-full border rounded px-2 py-1" value={formData.rtOvary.unit} onChange={(e) => handleChange("rtOvary", "unit", e.target.value)}>
      <option value="cm">cm</option>
          <option value="mm">mm</option>
      {/* add more units if needed */}
    </select>
  </div>
</div>

{/* RIGHT CYST MASS */}
<div className="grid grid-cols-5 gap-4 items-end mt-4">
  <div>
  <label className="block text-sm font-medium">Long</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.rtCystMass.LC}
    onChange={(e) => handleChange("rtCystMass", "LC", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">AP</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.rtCystMass.AP}
    onChange={(e) => handleChange("rtCystMass", "AP", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">TRANS</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.rtCystMass.TRANS}
    onChange={(e) => handleChange("rtCystMass", "TRANS", e.target.value)}
  />
</div>
<div>
  {/* You can continue with other fields or leave this div empty as needed */}
</div>

  <div>
    <label className="block text-sm font-medium">Units</label>
    <select className="w-full border rounded px-2 py-1" value={formData.rtCystMass.unit} onChange={(e) => handleChange("rtCystMass", "unit", e.target.value)}>
      <option value="cm">cm</option>
         <option value="mm">mm</option>
    </select>
  </div>
  <div className="pt-6">
   <button
  type="button"
  onClick={() => setShowRtCystMassComment((prev) => !prev)}
  className="text-lg font-bold text-blue-600 hover:text-blue-800"
>
  +
</button>

  </div>
</div>

{/* COMMENT FIELD */}
{showRtCystMassComment && (
  <div className="mt-2">
    <textarea
      placeholder="Enter Comments here..."
      className="w-full border rounded px-2 py-1"
      rows={3}
      value={formData.rtCystMassComment || ""}
      onChange={(e) => setFormData((prev) => ({ ...prev, rtCystMassComment: e.target.value }))}
    />
  </div>
)}


        {/* Left Ovary */}
   <div className="grid grid-cols-4 gap-4 items-end mt-12">
  <div>
    <label className="block text-sm font-medium">Lt OV LONG</label>
    <input
      type="number"
      min="0"
      step="0.1"
      className="w-full border rounded px-2 py-1"
      value={formData.ltOvary.LONG}
      onChange={(e) => handleChange("ltOvary", "LONG", e.target.value)}
    />
  </div>
  <div>
    <label className="block text-sm font-medium">Lt OV AP</label>
    <input
      type="number"
      min="0"
      step="0.1"
      className="w-full border rounded px-2 py-1"
      value={formData.ltOvary.AP}
      onChange={(e) => handleChange("ltOvary", "AP", e.target.value)}
    />
  </div>
  <div>
    <label className="block text-sm font-medium">Lt OV TRANS</label>
    <input
      type="number"
      min="0"
      step="0.1"
      className="w-full border rounded px-2 py-1"
      value={formData.ltOvary.TRANS}
      onChange={(e) => handleChange("ltOvary", "TRANS", e.target.value)}
    />
  </div>
  <div>
    <label className="block text-sm font-medium">Units</label>
    <select
      className="w-full border rounded px-2 py-1"
      value={formData.ltOvary.unit}
      onChange={(e) => handleChange("ltOvary", "unit", e.target.value)}
    >
      <option value="cm">cm</option>
      <option value="mm">mm</option>
    </select>
  </div>
</div>



        {/* Left Cyst/Mass */}
      <div className="grid grid-cols-5 gap-4 items-end mt-4">
<div>
  <label className="block text-sm font-medium">Long</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.ltCystMass.LC}
    onChange={(e) => handleChange("ltCystMass", "LC", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">AP</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.ltCystMass.AP}
    onChange={(e) => handleChange("ltCystMass", "AP", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">TRANS</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.ltCystMass.TRANS}
    onChange={(e) => handleChange("ltCystMass", "TRANS", e.target.value)}
  />
</div>

  <div>
    <label className="block text-sm font-medium">Units</label>
    <select className="w-full border rounded px-2 py-1" value={formData.ltCystMass.unit} onChange={(e) => handleChange("ltCystMass", "unit", e.target.value)}>
      <option value="cm">cm</option>
          <option value="mm">mm</option>
    </select>
  </div>
  <div className="pt-6">
    <button
      type="button"
      onClick={() => setShowLtCystMassComment(true)}
     className="text-lg font-bold text-blue-600 hover:text-blue-800"
    >
      +
    </button>
  </div>
</div>

{showLtCystMassComment && (
  <div className="mt-2">
    <textarea
      placeholder="Enter Comments here..."
      className="w-full border rounded px-2 py-1"
      rows={3}
      value={formData.ltCystMassComment || ""}
      onChange={(e) => setFormData((prev) => ({ ...prev, ltCystMassComment: e.target.value }))}
    />
  </div>
)}


        {/* Uterus */}
 <div className="grid grid-cols-4 gap-4 items-end mt-12">
  <div>
    <label className="block text-sm font-medium">UTERUS LONG</label>
    <input
      type="number"
      min="0"
      step="0.1"
      className="w-full border rounded px-2 py-1"
      value={formData.uterus.LONG}
      onChange={(e) => handleChange("uterus", "LONG", e.target.value)}
    />
  </div>
  <div>
    <label className="block text-sm font-medium">UTERUS AP</label>
    <input
      type="number"
      min="0"
      step="0.1"
      className="w-full border rounded px-2 py-1"
      value={formData.uterus.AP}
      onChange={(e) => handleChange("uterus", "AP", e.target.value)}
    />
  </div>
  <div>
    <label className="block text-sm font-medium">UTERUS TRANS</label>
    <input
      type="number"
      min="0"
      step="0.1"
      className="w-full border rounded px-2 py-1"
      value={formData.uterus.TRANS}
      onChange={(e) => handleChange("uterus", "TRANS", e.target.value)}
    />
  </div>
  <div>
    <label className="block text-sm font-medium">Units</label>
    <select
      className="w-full border rounded px-2 py-1"
      value={formData.uterus.unit}
      onChange={(e) => handleChange("uterus", "unit", e.target.value)}
    >
      <option value="cm">cm</option>
      <option value="mm">mm</option>
    </select>
  </div>
</div>



        {/* Fibroid */}
        <div className="grid grid-cols-5 gap-4 items-end mt-4">
<div>
  <label className="block text-sm font-medium">Fibroid LONG</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.fibroid.LONG}
    onChange={(e) => handleChange("fibroid", "LONG", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">Fibroid AP</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.fibroid.AP}
    onChange={(e) => handleChange("fibroid", "AP", e.target.value)}
  />
</div>
<div>
  <label className="block text-sm font-medium">Fibroid TRANS</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.fibroid.TRANS}
    onChange={(e) => handleChange("fibroid", "TRANS", e.target.value)}
  />
</div>

  <div>
    <label className="block text-sm font-medium">Units</label>
    <select className="w-full border rounded px-2 py-1" value={formData.fibroid.unit} onChange={(e) => handleChange("fibroid", "unit", e.target.value)}>
      <option value="cm">cm</option>
          <option value="mm">mm</option>
    </select>
  </div>
  <div className="pt-6">
    <button
      type="button"
      onClick={() => setShowFibroidComment(true)}
  className="text-lg font-bold text-blue-600 hover:text-blue-800"
    >
      +
    </button>
  </div>
</div>

{showFibroidComment && (
  <div className="mt-2">
    <textarea
      placeholder="Enter Comments here..."
      className="w-full border rounded px-2 py-1"
      rows={3}
      value={formData.fibroidComment || ""}
      onChange={(e) => setFormData((prev) => ({ ...prev, fibroidComment: e.target.value }))}
    />
  </div>
)}


        {/* Position */}
        <div className="mt-4">
          <h3 className="text-sm font-semibold">Position</h3>
          <div className="grid grid-cols-5 gap-4">
            {["NL", "AV", "RV", "TR", "TL"].map((pos) => (
              <label key={pos} className="flex items-center">
                <input
                  type="radio"
                  name="position"
                  value={pos}
                  checked={formData.position === pos}
                  onChange={(e) => handleChange(null, "position", e.target.value)}
                  className="mr-1"
                />
                {pos}
              </label>
            ))}
          </div>
        </div>

        {/* Endometrium */}
        <div className="mt-4">
          <h3 className="text-sm font-semibold">Endometrium</h3>
          <div className="grid grid-cols-3 gap-4">
          <div>
  <label className="block text-sm">Value</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.endometrium.value}
    onChange={(e) => handleChange("endometrium", "value", e.target.value)}
  />
</div>

            <div>
              <label className="block text-sm">Unit</label>
              <select className="w-full border rounded px-2 py-1" value={formData.endometrium.unit} onChange={(e) => handleChange("endometrium", "unit", e.target.value)}>
                <option value="cm">cm</option>
                    <option value="mm">mm</option>
              </select>
            </div>
        <div className="flex items-end space-x-2 w-full">
  {/* Fluid */}
 <div className="w-1/2">
  <label className="block text-sm mb-1">Fluid</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.endometrium.fluid}
    onChange={(e) => handleChange("endometrium", "fluid", e.target.value)}
  />
</div>

{/* Styled Slash Separator */}
<div className="flex items-center justify-center h-[38px] px-2 border rounded text-gray-700">
  /
</div>

{/* Mass */}
<div className="w-1/2">
  <label className="block text-sm mb-1">Mass</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.endometrium.mass}
    onChange={(e) => handleChange("endometrium", "mass", e.target.value)}
  />
</div>

</div>

          </div>
        </div>

        {/* Cul-de-Sac */}
   <div className="mt-4">
  <h3 className="text-sm font-semibold">Cul-de-Sac</h3>
  <div className="flex items-end space-x-2 w-full mt-2">
    {/* Net */}
  <div className="w-1/2">
  <label className="block text-sm mb-1">Net</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.culDeSac.net}
    onChange={(e) => handleChange("culDeSac", "net", e.target.value)}
  />
</div>

{/* Styled Slash Separator */}
<div className="flex items-center justify-center h-[38px] px-2 border rounded text-gray-700">
  /
</div>

{/* Fluid */}
<div className="w-1/2">
  <label className="block text-sm mb-1">Fluid</label>
  <input
    type="number"
    min="0"
    step="0.1"
    className="w-full border rounded px-2 py-1"
    value={formData.culDeSac.fluid}
    onChange={(e) => handleChange("culDeSac", "fluid", e.target.value)}
  />
</div>

  </div>
</div>


        {/* LMP */}
        <div className="mt-4">
          <h3 className="text-sm font-semibold">LMP</h3>
   <input
  type="number"
  className="w-full border rounded px-2 py-1"
  value={formData.lmp}
  onChange={(e) => handleChange(null, "lmp", e.target.value)}
/>

        </div>

        {/* Hormone Replacement */}
  {/* Hormone Replacement */}
<div className="mt-4">
  <div className="flex items-center justify-between">
    <h3 className="text-sm font-semibold">Hormone Replacement</h3>
    <button
      type="button"
      onClick={() => handleCommentToggle("hormoneReplacement")}
      className="text-lg font-bold text-blue-600 hover:text-blue-800"
    >
      +
    </button>
  </div>
  <div className="flex items-center mt-2">
    <label className="mr-2">
      <input
        type="radio"
        name="hormoneReplacement"
        value={true}
        checked={formData.hormoneReplacement === true}
        onChange={(e) =>
          handleChange(null, "hormoneReplacement", e.target.value === "true")
        }
        className="mr-1"
      />
      Yes
    </label>
    <label>
      <input
        type="radio"
        name="hormoneReplacement"
        value={false}
        checked={formData.hormoneReplacement === false}
        onChange={(e) =>
          handleChange(null, "hormoneReplacement", e.target.value === "true")
        }
        className="mr-1"
      />
      No
    </label>
  </div>

  {showComment.hormoneReplacement && (
    <textarea
      className="mt-2 w-full border rounded px-2 py-1"
      rows={2}
      placeholder="Enter comment..."
      value={formData.hormoneReplacementComment}
      onChange={(e) =>
        handleChange(null, "hormoneReplacementComment", e.target.value)
      }
    />
  )}
</div>

{/* Birth Control */}
<div className="mt-4">
  <div className="flex items-center justify-between">
    <h3 className="text-sm font-semibold">Birth Control</h3>
    <button
      type="button"
      onClick={() => handleCommentToggle("birthControl")}
      className="text-lg font-bold text-blue-600 hover:text-blue-800"
    >
      +
    </button>
  </div>
  <div className="flex items-center mt-2">
    <label className="mr-2">
      <input
        type="radio"
        name="birthControl"
        value={true}
        checked={formData.birthControl === true}
        onChange={(e) =>
          handleChange(null, "birthControl", e.target.value === "true")
        }
        className="mr-1"
      />
      Yes
    </label>
    <label>
      <input
        type="radio"
        name="birthControl"
        value={false}
        checked={formData.birthControl === false}
        onChange={(e) =>
          handleChange(null, "birthControl", e.target.value === "true")
        }
        className="mr-1"
      />
      No
    </label>
  </div>

  {showComment.birthControl && (
    <textarea
      className="mt-2 w-full border rounded px-2 py-1"
      rows={2}
      placeholder="Enter comment..."
      value={formData.birthControlComment}
      onChange={(e) =>
        handleChange(null, "birthControlComment", e.target.value)
      }
    />
  )}
</div>


        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input className="w-full border rounded px-2 py-1 mt-1" placeholder="Signature" value={formData.signature} onChange={(e) => handleChange(null, "signature", e.target.value)} />
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Save</button>
        </div>
      </div>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={() => setOpenToast(false)} />
    </div>
  );
};

export default PelvicUltrasoundForm;